import React from "react";
const FoundationGraphic = () => (
  <svg viewBox="0 0 338 18">
    <g stroke-linecap="round">
      <g
        transform="translate(0.000000, -151.000000)"
        stroke="currentColor"
        stroke-width="16"
      >
        <line x1="9.11" y1="160.29" x2="328.27" y2="160.29"></line>
      </g>
    </g>
  </svg>
);
export default FoundationGraphic;
